import { LetterTracking, LetterExchangePage } from "./LetterTracking";

const allCorrespondenceRoutes = [
  {
    path: "letterTracking",
    component: <LetterTracking />,
  },
  {
    path: "LetterExchange/:letter_id/:assigned_to/",
    component: <LetterExchangePage />,
  },
];

const LetterExchangePageRoute = {
  path: "LetterExchange/:letter_id/:assigned_to/",
  component: <LetterExchangePage />,
};
const LetterTrackingRoute = {
  path: "letterTracking",
  component: <LetterTracking />,
};

export default allCorrespondenceRoutes;

export { LetterTrackingRoute, LetterExchangePageRoute };
